
/**
 * CENTRALIZED ASSET CLASS ICONS
 * 
 * This file is the single source of truth for asset class icons and display names.
 * All provider implementations should reference these central definitions.
 */
import { LucideIcon, ChartBar as ChartBarIcon, Landmark, DollarSign, Shapes, Layers, Circle, ChartNoAxesCombined, BadgeDollarSign, PiggyBank, Building2, Bitcoin, Trophy, Wheat, SigmaSquare } from 'lucide-react';

export const ASSET_CLASS_ICONS: Record<string, LucideIcon> = {
  equity: ChartBarIcon,
  fixed_income: Landmark,
  cash: DollarSign,
  alternative: Shapes,
  multi_asset: Layers,
  unclassified: Circle,
  other: Circle,
} as const;

// For display purposes
export const ASSET_CLASS_DISPLAY_NAMES: Record<string, string> = {
  equity: 'Equity',
  fixed_income: 'Fixed Income',
  cash: 'Cash',
  alternative: 'Alternative',
  multi_asset: 'Multi-Asset',
  unclassified: 'Unclassified'
} as const;

export const ALTERNATIVE_ASSET_ICONS: Record<string, LucideIcon> = {
  private_equity: ChartNoAxesCombined,
  private_credit: BadgeDollarSign,
  private_debt: PiggyBank,
  real_estate: Building2,
  digital_assets: Bitcoin,
  collectibles: Trophy,
  commodities: Wheat,
  hedge_funds: SigmaSquare,
} as const;

export type AssetClassType = keyof typeof ASSET_CLASS_ICONS;
